import script from "./ManualStart.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualStart.vue?vue&type=script&setup=true&lang=js"

import "./ManualStart.vue?vue&type=style&index=0&id=06b03d66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06b03d66"]])

export default __exports__